import React from 'react';
import { useParams } from 'react-router-dom';
import { Box, Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import ExistingCustomerForm from '../components/ExistingCustomerForm';
import SalesEstimateStepper from '../../navigation/components/SalesEstimateStepper';
import EstimateInfoHeader from '../components/EstimateInfoHeader';
import { EstimateDetailsContext } from '../../estimateDetails/contexts/EstimateDetailsContext';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    minHeight: '100vh',
    width: '100%',
    padding: 0,
  },
  box: {
    width: '100%',
  },
  content: {
    marginLeft: '0px',
    padding: '80px 30px',
  },
}));

const NewRooftopEstimate: React.FC = () => {
  const classes = useStyles();

  const { estimateId } = useParams<{ estimateId: string }>();

  const [assetsFetched, setAssetsFetched] = React.useState(false);

  const { salesEstimate, fetchSalesEstimate } = React.useContext(EstimateDetailsContext);

  React.useEffect(() => {
    if (!assetsFetched) {
      setAssetsFetched(true);
      fetchSalesEstimate(estimateId);
    }
  }, [estimateId]);

  return (
    salesEstimate?.id && (
      <Box className={classes.box}>
        <SalesEstimateStepper activeStep={0} salesEstimateId={salesEstimate?.id} />
        <Grid item xs={12} md={12} style={{ marginBottom: 15 }}>
          <EstimateInfoHeader salesEstimate={salesEstimate} />
        </Grid>
        <Grid container>
          <Grid item xs={12} md={10}>
            <ExistingCustomerForm />
          </Grid>
        </Grid>
      </Box>
    )
  );
};

export default NewRooftopEstimate;
